import { MessagePreviewDraftProps } from "../types"
import React from "react"
import { useTheme } from '~/ui/styled'
import PreviewWrap from "./preview-wrap"
import PreviewText from "./preview-text"

const MessageDraft: React.FC<MessagePreviewDraftProps> = ({ draft }) => {
  const theme = useTheme()
  return (
    <PreviewWrap style={{ minWidth: 0 }}>
      <PreviewText color={theme.colors.danger} style={{ flexShrink: 0 }}>[草稿]</PreviewText>
      <PreviewText numberOfLines={1} style={{ flex: 1, minWidth: 0 }}> {draft} </PreviewText>
    </PreviewWrap>
  )
}
export default MessageDraft
